import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mandate-card',
  templateUrl: './mandate-card.component.html',
  styleUrls: ['./mandate-card.component.scss']
})
export class MandateCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
